import Command from '../../actions/command';
import {call, fork, put, take} from 'redux-saga/effects';
import {Action} from 'redux-actions';
import {AddGoogleRatingPayload} from '../../actions/companyCommand';
import Event from '../../actions/event';
import Api from '../../../api';

const onAddGoogleRatingData = function*(data: AddGoogleRatingPayload) {
    try {
        yield call(Api.Command.addGoogleRating, {
            companyId: data.companyId,
            googleRating: data.googleRating,
        });

        yield put(Event.Company.googleRatingAdded({
            ...data,
        }));

        yield put(Command.Notification.enqueueNotification({
            severity: 'success',
            message: 'Google Place-Id wurde geupdatet.',
        }));
    } catch (e) {
        yield put(Command.Notification.enqueueNotification({
            severity: 'error',
            message: 'Der Vorgang konnte nicht abgeschlossen werden.',
        }));
    }
};

export function* addGoogleRatingFlow() {
    while (true) {
        const action: Action<AddGoogleRatingPayload> = yield take(
            Command.Company.addGoogleRating.toString(),
        );

        yield fork(onAddGoogleRatingData, action.payload);
    }
}
